<template>
  <section class="section container pt-3">
    <div class="mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("neolink module settings") }}
      </h1>
    </div>

    <profiles-datatable />

    <token-datatable />
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
  change_active_tab,
} from "@/utils";
import { isEmpty } from "lodash";
import { v4 } from "uuid";
import ProfilesDatatable from "./profiles_datatable/Index.vue";
import TokenDatatable from "./token_datatable/Index.vue";
// import ProcessesDatatable from "./processes_datatable/Index.vue";

export default {
  name: "NeolinkSettings",
  components: { ProfilesDatatable, TokenDatatable },
  data() {
    return {
      meta: { profiles: [] },
    };
  },
  methods: {
    change_active_tab,
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    create() {
      let v = this;
      v.meta.profiles.push({ uuid: v4(), name: v.$t("new profile") });
    },
    configure_profile(profile) {
      let v = this;
      v.$refs.profile_modal.show_modal(profile);
    },
    profile_modified(profile) {
      let v = this;
      let trgt = v.meta.profiles.find((p) => p.uuid === profile.uuid);
      if (trgt) {
        Object.keys(profile).map((k) => {
          trgt[k] = profile[k];
        });
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
